<template>
	<div>
		<!--工具栏-->
		<Topbar />
		<!--图像展示区-->
		<ImageView class="top" />
		<!--缺陷记录区-->
		<div class="bottom">
			<ReferenceImage class="reference_view" />
			<DefectList class="defectList" :style="{ left: leftclientWidth }" />
			<Control class="control" />
		</div>
	</div>
</template>

<script>
	import { store } from './store'
	import Topbar from './Topbar'
	import ImageView from './ImageView'
	import DefectList from './List'
	import Control from './Control'
	import ReferenceImage from './ReferenceImage'
	import { mapGetters } from 'vuex'

	export default {
		components: {
			Topbar,
			ImageView,
			DefectList,
			Control,
			ReferenceImage,
		},
		data() {
			return {
				leftclientWidth: (document.body.clientHeight - 350) / 2 + 'px',
				data: store.state,
				tableHeight: 0,
			}
		},
		computed: {
			...mapGetters(['roleCodes', 'isPublic', 'userInfo']),
			/**
			 * 从URL参数中获取批次Id。
			 */
			batchId() {
				return this.$route.query.batch_id
			},
		},
		mounted() {},
		async created() {
			console.log(this.userInfo)
			//初始化缺陷浏览器。
			await store.initAsync(this.batchId, this.roleCodes, this.userInfo)
		},
	}
</script>

<style lang="less" scoped>
	body {
		overflow: hidden;
	}

	.top,
	.bottom {
		position: absolute;
	}

	.top {
		left: 0;
		top: 30px;
		right: 0;
		height: 320px;
		background-color: rgb(127, 127, 127);
		border-bottom: 1px #000 solid;
	}

	.bottom {
		bottom: 0;
		left: 0;
		right: 0;
		top: 350px;
		background-color: #eee;
	}

	.defectList {
		position: absolute;
		bottom: 2px;
		right: 0;
		top: 10px;
		/* left: 330px; */
	}

	.reference_view {
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		padding: 10px 0 0 5px;
	}

	.control {
		position: absolute;
		width: 120px;
		font-size: 10px;
		right: 10px;
		color: blue;
		top: 10px;
		bottom: 0;
		overflow: auto;
	}
</style>
